import React from 'react';

class PowerpackItem extends React.Component {

  constructor(props) {
    super(props);

	this.onSelectionButtonClicked = this.onSelectionButtonClicked.bind(this);
  }
  
  onSelectionButtonClicked() {
	if(!this.props.powerpack.Selected)
		this.props.onPowerpackSelectionToggled(this.props.powerpack);
  }
  
  powerpackSubText(powerpack){
	if(powerpack.PowerpackType == 1)
		return "Best for smaller sites";

	if(powerpack.PowerpackType == 2)
		return "Power up your CPU!";

	if(powerpack.PowerpackType == 3)
		return "Best for popular sites";

	if(powerpack.PowerpackType == 4)
		return "The ultimate package";
  }

  render() {

	var a = this;
	var selectedClass = 'powerpack';
	var price = a.props.powerpack.Price;
	
	return (
		<div className={'card ' + selectedClass}>
			<div className={a.props.powerpack.PowerpackType == 1 ? "card-header collapsed card-top" : "card-header collapsed"} data-toggle="collapse" data-target={'#' + a.props.powerpack.PowerpackType} role="tab">
				<label className="radio-container">
					<input type="radio" name="radio" value={a.props.powerpack.Name} checked={a.selected} onClick={() => a.onSelectionButtonClicked()} />
					<span className="radio-checkmark header-radio-checkmark"></span>
				</label>
                <a data-toggle="collapse" data-parent="#accordion">
                    {a.props.powerpack.Name} + &pound;{price.price} /{price.frequency}
                </a>
			</div>
			<div id={a.props.powerpack.PowerpackType} className="collapse" data-parent="#accordion">
				<div className="card-body">
					<div className="row row-powerpack-info">
						<p>
							{a.powerpackSubText(a.props.powerpack)}
						</p>
					</div>
					<div className="row-powerpack-info">
						<div className="container">
							<div className="row">
								<div className="col">
									<div className="powerpack-info powerpack-info-left z-pal-border-primary-faded text-center padding-0-left-t padding-0-right-t">
										<div className="powerpack-info-numbers">{a.props.powerpack.CPUs}</div>
										<div className="powerpack-info-text">vCPU CORE</div>
									</div>
								</div>
								<div className="col">
									<div className="powerpack-info powerpack-info-centre z-pal-border-primary-faded text-center">
										<div className="powerpack-info-numbers">{a.props.powerpack.Ram}</div>
										<div className="powerpack-info-text">GB RAM</div>
									</div>
								</div>
								<div className="col">
									<div className="powerpack-info powerpack-info-right z-pal-border-primary-faded text-center">
										<div className="powerpack-info-numbers">&pound;{a.props.powerpack.Price._decimal}</div>
										<div className="powerpack-info-text">PER MONTH</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
};

export default PowerpackItem;



// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Components/PowerpackItem.es6